import { IonCol, IonRow } from '@ionic/react';
import MaterialTable from 'material-table';
import React, { useEffect, useState } from 'react'
import db from '../../resources/db';
import { convertToGST_Purchase_Report } from './Purchase';
import { convertToGST_Sales_Report } from './Sales';
import tableIcons from '../../resources/tableIcons';

const Adjustments = ({ from, to }) => {

    const [adjustment, setAdjustment] = useState({
        purchaseReports: {
            data: [],
            columns: []
        },
        salesReports: {
            data: [],
            columns: []
        },
        adjustments: {
            data: [],
            columns: []
        }
    });

    useEffect(() => {
        calculate_Adjustments(from, to).then(data => {
            setAdjustment(data);
        })
        return () => {
            // cleanup
            setAdjustment({
                purchaseReports: { data: [], columns: [] },
                salesReports: { data: [], columns: [] },
                adjustments: { data: [], columns: [] }
            });
        }
    }, [from, to])

    const { purchaseReports, salesReports, adjustments } = adjustment;

    return (
        <div>
            <IonRow>
                <IonCol>
                    <MaterialTable title="Output Adjustments"
                        options={{
                            paging: false,
                            toolbar: false,
                            padding: 'dense',
                        }}
                        columns={[
                            { title: 'Output Adjustments', field: 'gstRate' },
                            { title: 'IGST', field: 'igst', type: 'currency', currencySetting: { currencyCode: 'INR' } },
                            { title: 'CGST', field: 'cgst', type: 'currency', currencySetting: { currencyCode: 'INR' } },
                            { title: 'SGST', field: 'sgst', type: 'currency', currencySetting: { currencyCode: 'INR' } },
                        ]} data={salesReports.data} icons={tableIcons} />
                </IonCol>
                <IonCol>
                    <MaterialTable title="Input Adjustments"
                        options={{
                            paging: false,
                            toolbar: false,
                            padding: 'dense',
                        }}
                        columns={[
                            { title: 'Input Adjustments', field: 'gstRate' },
                            { title: 'IGST', field: 'igst', type: 'currency', currencySetting: { currencyCode: 'INR' } },
                            { title: 'CGST', field: 'cgst', type: 'currency', currencySetting: { currencyCode: 'INR' } },
                            { title: 'SGST', field: 'sgst', type: 'currency', currencySetting: { currencyCode: 'INR' } },
                        ]} data={purchaseReports.data} icons={tableIcons} />
                </IonCol>
            </IonRow>
            <IonRow>
                <MaterialTable title="GST Payable"
                    options={{
                        paging: false,
                        // toolbar: false,
                        search: false,
                        padding: 'dense',
                        // tableLayout: 'fixed',
                    }}
                    columns={[
                        { title: 'GST Payable', field: 'title', cellStyle: { width: 300 } },
                        { title: 'IGST', field: 'igst', type: 'currency', currencySetting: { currencyCode: 'INR' } },
                        { title: 'CGST', field: 'cgst', type: 'currency', currencySetting: { currencyCode: 'INR' } },
                        { title: 'SGST', field: 'sgst', type: 'currency', currencySetting: { currencyCode: 'INR' } },
                    ]} data={adjustments.data} icons={tableIcons} />

            </IonRow>

            <p>
                ITC Current - Current Input Tax Credit (ITC) is the amount of tax that is credited to the taxpayer as a result of the tax paid by the taxpayer.
                The ITC is calculated on the basis of the tax paid by the taxpayer.
            </p>

        </div>
    )
}

export default Adjustments


export async function calculate_Adjustments(from, to) {
    const Purchase = await db.getPurchases();
    const Sales = await db.getInvoices();
    const purchase_report = convertToGST_Purchase_Report(Purchase, from, to);
    const sales_report = convertToGST_Sales_Report(Sales, from, to);

    const less_igst = purchase_report.totals.igst - sales_report.totals.igst;
    const less_cgst = purchase_report.totals.cgst - sales_report.totals.cgst;
    const less_sgst = purchase_report.totals.sgst - sales_report.totals.sgst;

    // const cross_igst = less_igst > (less_cgst + less_sgst) ? less_cgst + less_sgst : less_igst > less_cgst ? less_cgst : 0;
    // const cross_cgst = less_igst > (less_cgst + less_sgst) ? less_cgst : less_igst > less_cgst ? less_cgst : 0;
    // const cross_sgst = less_igst > (less_cgst + less_sgst) ? less_sgst : less_igst > less_cgst ? less_sgst : 0;

    const cross_igst = 0;
    const cross_cgst = 0;
    const cross_sgst = 0;

    const net_payable_igst = less_igst - cross_igst;
    const net_payable_cgst = less_cgst - cross_cgst;
    const net_payable_sgst = less_sgst - cross_sgst;



    return {
        purchaseReports: {
            data: [
                ...(purchase_report.gstTotal), purchase_report.totals
            ],
            columns: [
                { title: 'Input Adjustments', header: 'Input Adjustments', field: 'gstRate', key: 'gstRate', width: 20 },
                { title: 'IGST', header: 'IGST', field: 'igst', key: 'igst', width: 10 },
                { title: 'CGST', header: 'CGST', field: 'cgst', key: 'cgst', width: 10 },
                { title: 'SGST', header: 'SGST', field: 'sgst', key: 'sgst', width: 10 },
            ]
        },

        salesReports: {
            data: [
                ...(sales_report.gstTotal), sales_report.totals
            ],
            columns: [
                { title: 'Output Adjustments', header: 'Output Adjustments', field: 'gstRate', key: 'gstRate', width: 20 },
                { title: 'IGST', header: 'IGST', field: 'igst', key: 'igst', width: 10 },
                { title: 'CGST', header: 'CGST', field: 'cgst', key: 'cgst', width: 10 },
                { title: 'SGST', header: 'SGST', field: 'sgst', key: 'sgst', width: 10 },
            ]
        },

        adjustments: {
            data: [
                {
                    title: 'Current ITC',
                    igst: purchase_report.totals.igst,
                    cgst: purchase_report.totals.cgst,
                    sgst: purchase_report.totals.sgst,
                },
                {
                    title: 'Output',
                    igst: sales_report.totals.igst,
                    cgst: sales_report.totals.cgst,
                    sgst: sales_report.totals.sgst,
                },
                {
                    title: 'Less: Output Adjusted against Input',
                    igst: less_igst,
                    cgst: less_cgst,
                    sgst: less_sgst,
                },
                {
                    title: 'Cross Adjustments',
                    igst: cross_igst,
                    cgst: cross_cgst,
                    sgst: cross_sgst,
                },
                {
                    title: 'Net Payable (ITC Carry forward)',
                    igst: net_payable_igst,
                    cgst: net_payable_cgst,
                    sgst: net_payable_sgst,
                },
            ],
            columns: [
                { title: 'Adjustment', header: 'Adjustment', field: 'title', key: 'title', width: 35 },
                { title: 'IGST', header: 'IGST', field: 'igst', key: 'igst', width: 10 },
                { title: 'CGST', header: 'CGST', field: 'cgst', key: 'cgst', width: 10 },
                { title: 'SGST', header: 'SGST', field: 'sgst', key: 'sgst', width: 10 },
            ]
        }
    }

}